export const stepByStep = {
    id: 'step-by-step',
    schemaVersion: 2,
    covers: "A numbered procedure walked through in order, step by step. Suits 'how a treatment works' where the sequence itself is the point.",
    aspectRatios: ['portrait'],
    duration: {
        kind: 'fixed',
        frames: 1037,
    },
    root: {
        kind: 'leaf',
        id: 'main',
        spine: [
            {
                kind: 'media-track',
                id: 'broll',
                duration: {
                    kind: 'fill',
                },
                clips: {
                    source: 'query',
                    query: {
                        kind: 'asset-clips',
                        tag: 'procedure',
                        count: [1, 2],
                    },
                    required: true,
                },
                fit: 'contain-blur',
                kenBurnsOnImages: true,
                cuts: {
                    mode: 'at',
                    at: [
                        {
                            atSec: 4.033,
                            transition: 'cut',
                        },
                    ],
                },
            },
        ],
        overlays: [
            {
                kind: 'group',
                id: 'step-1-ghost-rotate',
                duration: {
                    kind: 'fixed',
                    frames: 322,
                },
                start: {
                    at: 'frame',
                    value: 125,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'text',
                    content: {
                        source: 'slot',
                        slot: {
                            source: 'query',
                            query: {
                                kind: 'content',
                                field: 'step1Ghost',
                            },
                            required: true,
                        },
                    },
                    style: 'heading',
                    styleOverride: {
                        color: 'transparent',
                        strokeWidth: 2,
                        strokeColor: 'rgba(255,255,255,0.55)',
                        fontSize: 491,
                        fontWeight: 400,
                        textTransform: 'uppercase',
                        letterSpacing: 0.02,
                        lineHeight: 1,
                        whiteSpace: 'nowrap',
                    },
                    align: 'center',
                    motion: {
                        token: 'ghost-rise',
                        params: {
                            entryDelay: 82,
                            drift: 198,
                        },
                    },
                },
            },
            {
                kind: 'group',
                id: 'step-1-ghost-slide',
                duration: {
                    kind: 'fixed',
                    frames: 240,
                },
                start: {
                    at: 'frame',
                    value: 207,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'text',
                    content: {
                        source: 'slot',
                        slot: {
                            source: 'query',
                            query: {
                                kind: 'content',
                                field: 'step1Ghost',
                            },
                            required: true,
                        },
                    },
                    style: 'heading',
                    styleOverride: {
                        color: 'transparent',
                        strokeWidth: 2,
                        strokeColor: 'rgba(255,255,255,0.55)',
                        fontSize: 491,
                        fontWeight: 400,
                        textTransform: 'uppercase',
                        letterSpacing: 0.02,
                        lineHeight: 1,
                        whiteSpace: 'nowrap',
                    },
                    align: 'center',
                    motion: {
                        token: 'ghost-fly-in',
                        params: {
                            entryDelay: 0,
                            drift: 198,
                        },
                    },
                },
            },
            {
                kind: 'group',
                id: 'step-2-ghost-rotate',
                duration: {
                    kind: 'fixed',
                    frames: 229,
                },
                start: {
                    at: 'frame',
                    value: 455,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'text',
                    content: {
                        source: 'slot',
                        slot: {
                            source: 'query',
                            query: {
                                kind: 'content',
                                field: 'step2Ghost',
                            },
                            required: true,
                        },
                    },
                    style: 'heading',
                    styleOverride: {
                        color: 'transparent',
                        strokeWidth: 2,
                        strokeColor: 'rgba(255,255,255,0.55)',
                        fontSize: 491,
                        fontWeight: 400,
                        textTransform: 'uppercase',
                        letterSpacing: 0.02,
                        lineHeight: 1,
                        whiteSpace: 'nowrap',
                    },
                    align: 'center',
                    motion: {
                        token: 'ghost-rise',
                        params: {
                            entryDelay: 100,
                            drift: 87,
                        },
                    },
                },
            },
            {
                kind: 'group',
                id: 'step-2-ghost-slide',
                duration: {
                    kind: 'fixed',
                    frames: 129,
                },
                start: {
                    at: 'frame',
                    value: 555,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'text',
                    content: {
                        source: 'slot',
                        slot: {
                            source: 'query',
                            query: {
                                kind: 'content',
                                field: 'step2Ghost',
                            },
                            required: true,
                        },
                    },
                    style: 'heading',
                    styleOverride: {
                        color: 'transparent',
                        strokeWidth: 2,
                        strokeColor: 'rgba(255,255,255,0.55)',
                        fontSize: 491,
                        fontWeight: 400,
                        textTransform: 'uppercase',
                        letterSpacing: 0.02,
                        lineHeight: 1,
                        whiteSpace: 'nowrap',
                    },
                    align: 'center',
                    motion: {
                        token: 'ghost-fly-in',
                        params: {
                            entryDelay: 0,
                            drift: 87,
                        },
                    },
                },
            },
            {
                kind: 'group',
                id: 'step-3-ghost-rotate',
                duration: {
                    kind: 'fixed',
                    frames: 236,
                },
                start: {
                    at: 'frame',
                    value: 692,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'text',
                    content: {
                        source: 'slot',
                        slot: {
                            source: 'query',
                            query: {
                                kind: 'content',
                                field: 'step3Ghost',
                            },
                            required: true,
                        },
                    },
                    style: 'heading',
                    styleOverride: {
                        color: 'transparent',
                        strokeWidth: 2,
                        strokeColor: 'rgba(255,255,255,0.55)',
                        fontSize: 491,
                        fontWeight: 400,
                        textTransform: 'uppercase',
                        letterSpacing: 0.02,
                        lineHeight: 1,
                        whiteSpace: 'nowrap',
                    },
                    align: 'center',
                    motion: {
                        token: 'ghost-rise',
                        params: {
                            entryDelay: 73,
                            drift: 121,
                        },
                    },
                },
            },
            {
                kind: 'group',
                id: 'step-3-ghost-slide',
                duration: {
                    kind: 'fixed',
                    frames: 163,
                },
                start: {
                    at: 'frame',
                    value: 765,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'text',
                    content: {
                        source: 'slot',
                        slot: {
                            source: 'query',
                            query: {
                                kind: 'content',
                                field: 'step3Ghost',
                            },
                            required: true,
                        },
                    },
                    style: 'heading',
                    styleOverride: {
                        color: 'transparent',
                        strokeWidth: 2,
                        strokeColor: 'rgba(255,255,255,0.55)',
                        fontSize: 491,
                        fontWeight: 400,
                        textTransform: 'uppercase',
                        letterSpacing: 0.02,
                        lineHeight: 1,
                        whiteSpace: 'nowrap',
                    },
                    align: 'center',
                    motion: {
                        token: 'ghost-fly-in',
                        params: {
                            entryDelay: 0,
                            drift: 121,
                        },
                    },
                },
            },
            {
                kind: 'group',
                id: 'opening-headline',
                duration: {
                    kind: 'fixed',
                    frames: 107,
                },
                start: {
                    at: 'frame',
                    value: 28,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.4883,
                    width: 0.8,
                },
                root: {
                    kind: 'text',
                    content: {
                        source: 'slot',
                        slot: {
                            source: 'query',
                            query: {
                                kind: 'content',
                                field: 'hook',
                            },
                            required: true,
                        },
                    },
                    style: 'heading',
                    styleOverride: {
                        colorRole: 'onPrimary',
                        textTransform: 'uppercase',
                        fontSize: 51,
                        fontWeight: 700,
                        lineHeight: 1,
                        whiteSpace: 'nowrap',
                        letterSpacing: 0.02,
                    },
                    align: 'center',
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                anchor: {
                                    at: 'start',
                                },
                                duration: 12,
                                easing: 'linear',
                            },
                            {
                                channel: 'opacity',
                                from: 1,
                                to: 0,
                                anchor: {
                                    at: 'end',
                                    frame: 17,
                                },
                                duration: 17,
                                easing: 'linear',
                            },
                        ],
                    },
                },
            },
            {
                kind: 'info-card',
                id: 'opening-mark',
                layout: 'centered',
                logo: {
                    url: {
                        source: 'query',
                        query: {
                            kind: 'brand',
                            field: 'logoUrl',
                        },
                        required: false,
                    },
                    position: 'top',
                    size: 'hero',
                    widthRatio: 0.6,
                },
                background: {
                    kind: 'solid',
                    color: 'transparent',
                },
                entrance: {
                    animation: 'fade-in',
                },
                motion: {
                    tracks: [
                        {
                            channel: 'opacity',
                            from: 0,
                            to: 1,
                            anchor: {
                                at: 'start',
                            },
                            duration: 14,
                            easing: 'linear',
                        },
                        {
                            channel: 'opacity',
                            from: 1,
                            to: 0,
                            anchor: {
                                at: 'end',
                                frame: 17,
                            },
                            duration: 17,
                            easing: 'linear',
                        },
                    ],
                },
                duration: {
                    kind: 'fixed',
                    frames: 107,
                },
                start: {
                    at: 'frame',
                    value: 28,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5997,
                    width: 1,
                },
            },
            {
                kind: 'group',
                id: 'step-1-card',
                duration: {
                    kind: 'fixed',
                    frames: 132,
                },
                start: {
                    at: 'frame',
                    value: 118,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5083,
                    width: 0.88,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 62,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'step1Label',
                                    },
                                    required: true,
                                },
                            },
                            style: 'heading',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 91,
                                fontWeight: 700,
                                lineHeight: 1,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.02,
                            },
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'step1Title',
                                    },
                                    required: true,
                                },
                            },
                            style: 'heading',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 70,
                                fontWeight: 300,
                                lineHeight: 1,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.05,
                            },
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                anchor: {
                                    at: 'start',
                                },
                                duration: 17,
                                easing: 'linear',
                            },
                            {
                                channel: 'opacity',
                                from: 1,
                                to: 0,
                                anchor: {
                                    at: 'end',
                                    frame: 14,
                                },
                                duration: 14,
                                easing: 'linear',
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'step-2-card',
                duration: {
                    kind: 'fixed',
                    frames: 128,
                },
                start: {
                    at: 'frame',
                    value: 448,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5083,
                    width: 0.88,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 62,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'step2Label',
                                    },
                                    required: true,
                                },
                            },
                            style: 'heading',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 91,
                                fontWeight: 700,
                                lineHeight: 1,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.02,
                            },
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'step2Title',
                                    },
                                    required: true,
                                },
                            },
                            style: 'heading',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 70,
                                fontWeight: 300,
                                lineHeight: 1,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.05,
                            },
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                anchor: {
                                    at: 'start',
                                },
                                duration: 14,
                                easing: 'linear',
                            },
                            {
                                channel: 'opacity',
                                from: 1,
                                to: 0,
                                anchor: {
                                    at: 'end',
                                    frame: 14,
                                },
                                duration: 14,
                                easing: 'linear',
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'step-3-card',
                duration: {
                    kind: 'fixed',
                    frames: 128,
                },
                start: {
                    at: 'frame',
                    value: 685,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5055,
                    width: 0.88,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 60,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'step3Label',
                                    },
                                    required: true,
                                },
                            },
                            style: 'heading',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 91,
                                fontWeight: 700,
                                lineHeight: 1,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.02,
                            },
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'step3Title',
                                    },
                                    required: true,
                                },
                            },
                            style: 'heading',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'uppercase',
                                fontSize: 50,
                                fontWeight: 300,
                                lineHeight: 1,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.05,
                            },
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                anchor: {
                                    at: 'start',
                                },
                                duration: 14,
                                easing: 'linear',
                            },
                            {
                                channel: 'opacity',
                                from: 1,
                                to: 0,
                                anchor: {
                                    at: 'end',
                                    frame: 14,
                                },
                                duration: 14,
                                easing: 'linear',
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'step-1-body',
                duration: {
                    kind: 'fixed',
                    frames: 185,
                },
                start: {
                    at: 'frame',
                    value: 257,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5044,
                    width: 0.74,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 12,
                    align: 'center',
                    children: [
                        {
                            kind: 'stack',
                            direction: 'v',
                            gap: 32,
                            align: 'center',
                            children: [
                                {
                                    kind: 'text',
                                    content: {
                                        source: 'slot',
                                        slot: {
                                            source: 'query',
                                            query: {
                                                kind: 'content',
                                                field: 'step1LeadA',
                                            },
                                            required: true,
                                        },
                                    },
                                    style: 'heading',
                                    styleOverride: {
                                        colorRole: 'onPrimary',
                                        textTransform: 'none',
                                        fontSize: 76,
                                        fontWeight: 700,
                                        lineHeight: 1,
                                        whiteSpace: 'nowrap',
                                    },
                                    align: 'center',
                                },
                                {
                                    kind: 'text',
                                    content: {
                                        source: 'slot',
                                        slot: {
                                            source: 'query',
                                            query: {
                                                kind: 'content',
                                                field: 'step1LeadB',
                                            },
                                            required: true,
                                        },
                                    },
                                    style: 'heading',
                                    styleOverride: {
                                        colorRole: 'onPrimary',
                                        textTransform: 'none',
                                        fontSize: 76,
                                        fontWeight: 700,
                                        lineHeight: 1,
                                        whiteSpace: 'nowrap',
                                    },
                                    align: 'center',
                                },
                            ],
                        },
                        {
                            kind: 'stack',
                            direction: 'v',
                            gap: 24,
                            align: 'center',
                            children: [
                                {
                                    kind: 'text',
                                    content: {
                                        source: 'slot',
                                        slot: {
                                            source: 'query',
                                            query: {
                                                kind: 'content',
                                                field: 'step1BodyA',
                                            },
                                            required: true,
                                        },
                                    },
                                    style: 'heading',
                                    styleOverride: {
                                        colorRole: 'onPrimary',
                                        textTransform: 'none',
                                        fontSize: 52,
                                        fontWeight: 300,
                                        lineHeight: 1,
                                        whiteSpace: 'nowrap',
                                    },
                                    align: 'center',
                                },
                                {
                                    kind: 'text',
                                    content: {
                                        source: 'slot',
                                        slot: {
                                            source: 'query',
                                            query: {
                                                kind: 'content',
                                                field: 'step1BodyB',
                                            },
                                            required: true,
                                        },
                                    },
                                    style: 'heading',
                                    styleOverride: {
                                        colorRole: 'onPrimary',
                                        textTransform: 'none',
                                        fontSize: 52,
                                        fontWeight: 300,
                                        lineHeight: 1,
                                        whiteSpace: 'nowrap',
                                    },
                                    align: 'center',
                                },
                                {
                                    kind: 'text',
                                    content: {
                                        source: 'slot',
                                        slot: {
                                            source: 'query',
                                            query: {
                                                kind: 'content',
                                                field: 'step1BodyC',
                                            },
                                            required: true,
                                        },
                                    },
                                    style: 'heading',
                                    styleOverride: {
                                        colorRole: 'onPrimary',
                                        textTransform: 'none',
                                        fontSize: 52,
                                        fontWeight: 300,
                                        lineHeight: 1,
                                        whiteSpace: 'nowrap',
                                    },
                                    align: 'center',
                                },
                            ],
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                anchor: {
                                    at: 'start',
                                },
                                duration: 14,
                                easing: 'linear',
                            },
                            {
                                channel: 'opacity',
                                from: 1,
                                to: 0,
                                anchor: {
                                    at: 'end',
                                    frame: 14,
                                },
                                duration: 14,
                                easing: 'linear',
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'step-2-body',
                duration: {
                    kind: 'fixed',
                    frames: 100,
                },
                start: {
                    at: 'frame',
                    value: 583,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.4802,
                    width: 0.82,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 21,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'step2Lead',
                                    },
                                    required: true,
                                },
                            },
                            style: 'heading',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 70,
                                fontWeight: 700,
                                lineHeight: 1,
                                whiteSpace: 'nowrap',
                            },
                            align: 'center',
                        },
                        {
                            kind: 'stack',
                            direction: 'v',
                            gap: 21,
                            align: 'center',
                            children: [
                                {
                                    kind: 'text',
                                    content: {
                                        source: 'slot',
                                        slot: {
                                            source: 'query',
                                            query: {
                                                kind: 'content',
                                                field: 'step2BodyA',
                                            },
                                            required: true,
                                        },
                                    },
                                    style: 'heading',
                                    styleOverride: {
                                        colorRole: 'onPrimary',
                                        textTransform: 'none',
                                        fontSize: 52,
                                        fontWeight: 300,
                                        lineHeight: 1,
                                        whiteSpace: 'nowrap',
                                    },
                                    align: 'center',
                                },
                                {
                                    kind: 'text',
                                    content: {
                                        source: 'slot',
                                        slot: {
                                            source: 'query',
                                            query: {
                                                kind: 'content',
                                                field: 'step2BodyB',
                                            },
                                            required: true,
                                        },
                                    },
                                    style: 'heading',
                                    styleOverride: {
                                        colorRole: 'onPrimary',
                                        textTransform: 'none',
                                        fontSize: 52,
                                        fontWeight: 300,
                                        lineHeight: 1,
                                        whiteSpace: 'nowrap',
                                    },
                                    align: 'center',
                                },
                            ],
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                anchor: {
                                    at: 'start',
                                },
                                duration: 14,
                                easing: 'linear',
                            },
                            {
                                channel: 'opacity',
                                from: 1,
                                to: 0,
                                anchor: {
                                    at: 'end',
                                    frame: 14,
                                },
                                duration: 14,
                                easing: 'linear',
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'step-3-body',
                duration: {
                    kind: 'fixed',
                    frames: 105,
                },
                start: {
                    at: 'frame',
                    value: 823,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5169,
                    width: 0.9,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 22,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'step3Lead',
                                    },
                                    required: true,
                                },
                            },
                            style: 'heading',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 60,
                                fontWeight: 700,
                                lineHeight: 1,
                                whiteSpace: 'nowrap',
                            },
                            align: 'center',
                        },
                        {
                            kind: 'stack',
                            direction: 'v',
                            gap: 21,
                            align: 'center',
                            children: [
                                {
                                    kind: 'text',
                                    content: {
                                        source: 'slot',
                                        slot: {
                                            source: 'query',
                                            query: {
                                                kind: 'content',
                                                field: 'step3BodyA',
                                            },
                                            required: true,
                                        },
                                    },
                                    style: 'heading',
                                    styleOverride: {
                                        colorRole: 'onPrimary',
                                        textTransform: 'none',
                                        fontSize: 56,
                                        fontWeight: 300,
                                        lineHeight: 1,
                                        whiteSpace: 'nowrap',
                                    },
                                    align: 'center',
                                },
                                {
                                    kind: 'text',
                                    content: {
                                        source: 'slot',
                                        slot: {
                                            source: 'query',
                                            query: {
                                                kind: 'content',
                                                field: 'step3BodyB',
                                            },
                                            required: true,
                                        },
                                    },
                                    style: 'heading',
                                    styleOverride: {
                                        colorRole: 'onPrimary',
                                        textTransform: 'none',
                                        fontSize: 56,
                                        fontWeight: 300,
                                        lineHeight: 1,
                                        whiteSpace: 'nowrap',
                                    },
                                    align: 'center',
                                },
                            ],
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                anchor: {
                                    at: 'start',
                                },
                                duration: 14,
                                easing: 'linear',
                            },
                            {
                                channel: 'opacity',
                                from: 1,
                                to: 0,
                                anchor: {
                                    at: 'end',
                                    frame: 14,
                                },
                                duration: 14,
                                easing: 'linear',
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'close-fade',
                start: {
                    at: 'frame',
                    value: 909,
                },
                duration: {
                    kind: 'fixed',
                    frames: 128,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: '#120D07',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                        adoptLogoScrim: true,
                    },
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                anchor: {
                                    at: 'start',
                                },
                                duration: 36,
                                easing: 'linear',
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'close-mark',
                start: {
                    at: 'frame',
                    value: 925,
                },
                duration: {
                    kind: 'fixed',
                    frames: 112,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 0.6,
                },
                root: {
                    kind: 'logo',
                    url: {
                        source: 'query',
                        query: {
                            kind: 'brand',
                            field: 'logoUrl',
                        },
                        required: false,
                    },
                    width: 1,
                    entrance: 'none',
                    motion: {
                        tracks: [
                            {
                                channel: 'y',
                                from: 0.12,
                                to: 0,
                                duration: 14,
                                easing: 'ease-out',
                            },
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                duration: 8,
                                easing: 'ease-out',
                            },
                        ],
                    },
                },
            },
        ],
    },
    globals: {
        audio: {
            music: {
                source: 'query',
                query: {
                    kind: 'music',
                },
                required: false,
            },
        },
    },
    content: {
        hook: {
            type: 'text',
            maxChars: 25,
            description: "Names ONE process in 'How to X' form — everything below is a stage of it. Ends where the clinic's name begins, because the wordmark follows it on screen. Source shape: \"HOW TO RENT A ROOM AT\".",
        },
        step1Label: {
            type: 'text',
            maxChars: 10,
            description: 'The step marker, literally. Source shape: "STEP 1" — this IS the text, not a description of the stage.',
        },
        step1Title: {
            type: 'text',
            maxChars: 20,
            description: 'The stage as an IMPERATIVE the reader performs. Source shape: "CHOOSE YOUR ROOM".',
        },
        step1Ghost: {
            type: 'text',
            maxChars: 10,
            description: "The ONE WORD drawn huge behind step one — an outline that bleeds off both edges of the frame by design, so it is a motif rather than a line to read. The verb of `step1Title` ('CHOOSE YOUR ROOM' → 'CHOOSE'). One word, no punctuation.",
        },
        step1LeadA: {
            type: 'text',
            maxChars: 16,
            description: 'Step one\'s instruction, line 1 — written to someone doing it. Source shape: "Browse our 8".',
        },
        step1LeadB: {
            type: 'text',
            maxChars: 20,
            description: 'Line 2, continuing that instruction. Source shape: "London locations".',
        },
        step1BodyA: {
            type: 'text',
            maxChars: 28,
            description: 'Line 3, continuing on. Source shape: "and choose the beauty or".',
        },
        step1BodyB: {
            type: 'text',
            maxChars: 18,
            description: 'Line 4 — the shortest line, so it carries a pivot rather than a new idea. Source shape: "treatment room".',
        },
        step1BodyC: {
            type: 'text',
            maxChars: 28,
            description: 'Line 5, closing step one on what the reader has chosen. Source shape: "that suits your business".',
        },
        step2Label: {
            type: 'text',
            maxChars: 10,
            description: 'The step marker. Source shape: "STEP 2".',
        },
        step2Title: {
            type: 'text',
            maxChars: 18,
            description: 'Stage two as an imperative — the step ON from stage one. Source shape: "BOOK A VIEWING".',
        },
        step2Ghost: {
            type: 'text',
            maxChars: 10,
            description: 'The one-word verb behind step two, matching `step2Title`. Same motif as `step1Ghost` and it must be a DIFFERENT word — the three ghosts read as a progression.',
        },
        step2Lead: {
            type: 'text',
            maxChars: 24,
            description: 'Step two\'s instruction, opening line. Source shape: "Visit the space in person."',
        },
        step2BodyA: {
            type: 'text',
            maxChars: 32,
            description: 'Continues it, saying what the clinic does for them. Source shape: "We\'ll show you the rooms and".',
        },
        step2BodyB: {
            type: 'text',
            maxChars: 29,
            description: 'Closes step two. Source shape: "answer all your questions".',
        },
        step3Label: {
            type: 'text',
            maxChars: 10,
            description: 'The step marker. Source shape: "STEP 3".',
        },
        step3Title: {
            type: 'text',
            maxChars: 27,
            description: 'Stage three as an imperative — the one where they are underway. Source shape: "MOVE IN & START EARNING".',
        },
        step3Ghost: {
            type: 'text',
            maxChars: 10,
            description: 'The one-word verb behind step three, matching `step3Title`. The last of the three, so it should be the word that sounds like arriving.',
        },
        step3Lead: {
            type: 'text',
            maxChars: 29,
            description: 'Step three\'s instruction, opening line. Source shape: "Sign your flexible lease,"',
        },
        step3BodyA: {
            type: 'text',
            maxChars: 32,
            description: 'Continues it. Source shape: "move into your private room,"',
        },
        step3BodyB: {
            type: 'text',
            maxChars: 31,
            description: 'The last words in the video — leaves the reader already doing the thing. Source shape: "and start welcoming clients".',
        },
    },
    structure: 'A HOW-TO. `hook` names one process in \'How to X\' form, and everything below is a stage of THAT process in order — not three tips. Each step is a marker, an imperative title, and instructions written to someone doing it. The source is: "HOW TO RENT A ROOM AT [clinic]" — "STEP 1 / CHOOSE YOUR ROOM" — "STEP 2 / BOOK A VIEWING" — "STEP 3 / MOVE IN & START EARNING". Step 3 ends with the client actually underway. Behind each step a single WORD is drawn huge in outline — `step1Ghost`, `step2Ghost`, `step3Ghost` — and it is the verb of that step\'s title, so the three of them read as the progression on their own.',
};
//# sourceMappingURL=step-by-step.js.map